import {
  IExpandedMailingRule,
  AggregationTypeEnum,
  CorporateTypeEnum,
  ISystemField,
} from 'interfaces/MailingRule';

export const getInitialValues = (systemIds: string[]): IExpandedMailingRule => {
  const systems = systemIds.reduce((allSystems, id) => {
    allSystems[id] = [];
    return allSystems;
  }, {} as ISystemField);

  return {
    ...initialValues,
    systems,
  };
};

const initialValues: IExpandedMailingRule = {
  _id: '',
  id: '',
  serviceCategory: '',
  name: '',
  aggregationType: AggregationTypeEnum.contract,

  customerAging: {
    min: 0,
    max: 0,
  },

  shouldFilterOnContractAging: false,
  contractAging: {
    min: 0,
    max: 0,
  },

  customerType: [],
  corporateType: Object.values(CorporateTypeEnum),

  propensity: [],

  systems: {
    tv: [],
    movel: [],
    fixa_r1: [],
    fixa_r2: [],
  },

  billingType: [],

  uf: [],

  excludeExemption: false,

  activeOffer: [],

  customerDebtsSum: {
    min: 0,
    max: 0,
  },
  contractDebtsSum: {
    min: 0,
    max: 0,
  },
  customerContractsSum: {
    min: 0,
    max: 0,
  },
  contractInvoicesSum: {
    min: 0,
    max: 0,
  },

  permanenceType: '',
  permanenceInDays: 0,
  permanenceUntilDate: new Date().toString(),
  paymentRemunerationDays: 1,

  weekDaysToExecute: 0,
  debtsDistribution: '',

  shouldIncludeNewInvoice: false,
  invoiceAgingToInclude: {
    min: 0,
    max: 0,
  },
  periodUpdateDebt: 1,

  selectedEPS: {},
  status: 'CREATED',
};

export default initialValues;
